module.exports = __webpack_public_path__ + "img/294.d190affe.png";